'use client';

import { createIntl } from '@formatjs/intl';
import type { userAgent } from 'next/server';
import { PropsWithChildren } from 'react';
import { IntlProvider } from 'react-intl';
import { Provider } from 'react-redux';
import type { Bootstrap } from '@alltrails/networking/types/Bootstrap';
import type Experiments from '@alltrails/types/Experiments';
import { buildStore } from '../utils/redux';

type Props = {
  bootstrap: Bootstrap;
  browser: ReturnType<typeof userAgent>['browser'];
  experiments: Experiments;
  messages: ReturnType<typeof createIntl>['messages'];
  locale: ReturnType<typeof createIntl>['locale'];
  irclickid?: string;
};

export default function CustomProvider({ bootstrap, browser, experiments, messages, locale, children, irclickid }: PropsWithChildren<Props>) {
  const store = buildStore({
    algoliaConfigs: bootstrap.algoliaConfig,
    amplitudeAnalyticsSettings: bootstrap.amplitudeAnalyticsSettings,
    browser,
    context: bootstrap.context,
    currencyCode: bootstrap.currencyCode,
    experiments,
    features: bootstrap.features,
    irclickid,
    plans: bootstrap.plans,
    requestCountryCode: bootstrap.requestCountryCode
  });

  return (
    <IntlProvider messages={messages} locale={locale}>
      <Provider store={store}>{children}</Provider>
    </IntlProvider>
  );
}
